<template>
    <tab-section title="Sustainability Programs">
        <template v-slot:title-actions>
            <a v-if="editable" href class="uk-button uk-button-link" @click.prevent="create_record">
                <open-icon glyph="plus" />
            </a>
        </template>

        <data-table
            :id="`project-${record.id}-awards`"
            :columns="visible_columns"
            :rows="filtered_rows"
            :search="state.search"
            :total="state.total"
            :found="state.found"
            :current-page="state.page"
            :total-pages="nb_pages"
            :searchable="false"
            table-class="lam-subrecords-list"
            empty-title="None"
            @sort="sort_by"
            @page="goto_page"
        >

            <template
                v-slot:summary="{ row }"
            >
                <h6>{{ row.sustainability_program }}</h6>
            </template>
            <template
                v-slot:tbody="{ row, field }"
            >
                <form-checkbox
                    v-if="field === 'achieved'"
                    :id="`program-achieved-${row.id}`"
                    v-model="row.achieved"
                    name="achieved"
                    :error="has_error('achieved')"
                    class="uk-margin-small-top uk-text-center"
                    @input="save_for_record_id(row.id, $event, 'achieved')"
                />
                <form-select-combo
                    v-else-if="field === 'sustainability_program'"
                    :id="`program-sustainability_program-${row.id}`"
                    name="sustainability_program"
                    v-model="row.sustainability_program"
                    :error="has_error('sustainability_program')"
                    :editable="editable"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_for_record_id(row.id, $event, 'sustainability_program')"
                />
                <form-select
                    v-else-if="field === 'leed_level_sought'"
                    :id="`program-leed_level_sought-${row.id}`"
                    name="leed_level_sought"
                    v-model="row.leed_level_sought"
                    :options="leed_levels"
                    empty-label="(None)"
                    :editable="editable"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_for_record_id(row.id, $event, 'leed_level_sought')"
                />
                <form-select
                    v-else-if="field === 'leed_lam_services'"
                    :id="`program-leed_lam_services-${row.id}`"
                    name="leed_lam_services"
                    v-model="row.leed_lam_services"
                    :options="leed_lam_services"
                    empty-label="(None)"
                    :editable="editable"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_for_record_id(row.id, $event, 'leed_lam_services')"
                />
                <form-input
                    v-else-if="field === 'credit'"
                    :id="`program-credit-${row.id}`"
                    name="credit"
                    v-model="row.credit"
                    :editable="editable"
                    :required="false"
                    class="uk-width-1-1"
                    @input="save_for_record_id(row.id, $event, 'credit')"
                />
                <span v-else-if="field === 'buttons'">
                    <base-button
                        size="small"
                        color="danger"
                        @click.prevent.stop="remove(row)"
                    >
                        <open-icon glyph="trash" />
                    </base-button>
                </span>
                <span v-else>{{ row[field] }}</span>
            </template>
        </data-table>

        <div class="uk-grid uk-grid-small uk-margin-top">
            <div class="uk-width-1-1">
                <form-text-area
                    v-if="editable"
                    id="sustainability_notes"
                    name="sustainability_notes"
                    v-model="record.sustainability_notes"
                    placeholder="Sustainability Notes..."
                    width="1-1"
                    :required="false"
                    @input="save_field"
                />
                <p v-else-if="!!record.sustainability_notes">{{ record.sustainability_notes }}</p>
            </div>
        </div>
    </tab-section>
</template>

<script type="text/javascript">
import is_project_data_source_tab_section from "../mixins/IsProjectDataSourceTabSection"
import string_utilities from "../../../mixins/StringUtilities"

import FormCheckbox from "../../../ui/FormCheckbox"
import FormSelectCombo from "../../../ui/FormSelectCombo"
import FormSelect from "../../../ui/FormSelect"
import FormInput from "../../../ui/FormInput"
import FormTextArea from "../../../ui/FormTextArea"
import BaseButton from "../../../ui/BaseButton"
import OpenIcon from "../../../ui/OpenIcon"

export default {
    mixins: [is_project_data_source_tab_section, string_utilities],
    components: {
        FormCheckbox,
        FormSelectCombo,
        FormSelect,
        FormInput,
        FormTextArea,
        BaseButton,
        OpenIcon
    },
    methods: {
        remove (record) {
            const identifier = record.sustainability_program || "this program"
            this.$confirm({
                type: "error",
                title: "Delete Sustainability Program",
                message: `Do you really want to delete ${identifier}? Once it's gone, it's gone...`,
                cancel: "Keep It",
                ok: "Delete It",
                then: (confirmed) => {
                    if(confirmed) this.delete_record(record)
                }
            })
        }
    },
    computed: {
        leed_levels () {
            return this.dictionary("leed_level")
        },
        leed_lam_services () {
            return this.dictionary("leed_lam_service")
        }
    },
    data () {
        return {
            entity: "project_sustainability_program",
            columns: {
                achieved: { label: "Achieved", sort: false, type: "plain" },
                sustainability_program: { label: "Program", sort: null, type: "plain", cell_class: "uk-width-2-10" },
                leed_level_sought: { label: "Level Sought", sort: null, type: "plain", cell_class: "uk-width-2-10" },
                leed_lam_services: { label: "Lam Services", sort: null, type: "plain", cell_class: "uk-width-3-10" },
                credit: { label: "Credit(s)", sort: false, type: "plain", cell_class: "uk-width-3-10-" },
                buttons: { label: " ", sort: false, type: "plain", cell_class: "uk-text-right lam-col-user-initials" },
                project_id: { label: "Project ID", sort: false, type: "plain" }
            }
        }
    }
}
</script>
